<script>
    import { onMount, onDestroy } from 'svelte';
    import { currentUser } from './stores/user.js';
    // import { routeIsActive } from 'svelte-router-spa'
    // import { navigateTo } from 'svelte-router-spa'
    import { db } from './firestore';

    let userListener;
    let authStateChangedListener;

    onMount(() => {
        authStateChangedListener = firebase.auth().onAuthStateChanged(async function(user) {
            if (user) {
                // User is signed in
                console.log('UserObserver User just signed in');
                // if(user.displayName == null)
                //     return;
                /*Auto redirect if already logged in user is on login page*/
                // if(routeIsActive('login'))
                //     navigateTo('/');

                userListener = db.collection("users").doc(user.uid)
                        .onSnapshot((doc) => {
                       currentUser.setViaAuthUser(user, doc.data());
                    }, function(error) {
                        console.log(error);
                    });
                //userListener = await currentUser.setViaAuthUser(user); // Simple version directly setting the userAuth object: currentUser.set(user);
                console.log('currentUser:', $currentUser);
                console.log(user);
                // TEST CUSTOM CLAIMS
                user.getIdTokenResult().then((idTokenResult) => { console.log('observer - claims:', idTokenResult.claims.tenants); })
                                       .catch((error) => { console.log('ERROR observer - claims:', error); });
            } else {
                // User is signed out
                console.log('UserObserver - User just signed out');
                currentUser.reset(); // The currentUser then automatically resets the currentTenant as well :-)
                // currentUser.set(null);
            }
        });
    })

    onDestroy(()=>{
        userListener();
        authStateChangedListener();
    })
</script>